import ApiService from "@/core/services/api.service";

const mutations = {
  /**
   * Set is busy
   *
   * @param state
   * @param isBusy
   */
  setEmployeeAttendanceTimeBusy(state, isBusy) {
    state.isBusy = isBusy;
  },
};

const state = {
  isBusy: false,
};

const getters = {
  getEmployeeAttendanceTimeBusy: (state) => state.isBusy,
};

const actions = {
  updateEmployeeAttendanceTime(context, payload) {
    ApiService.setHeader();

    context.commit("setEmployeeAttendanceTimeBusy", true);

    return ApiService.post(
      "employee/attendance/admin/time/update",
      payload.form
    )
      .then(() => {
        console.log("Updated ", payload.form);
      })
      .finally(() => context.commit("setEmployeeAttendanceTimeBusy", false));
  },
};

export default {
  actions,
  mutations,
  state,
  getters,
};
